import { useMemo } from 'react';
import jwt_decode from 'jwt-decode';
import useReduxState from './useReduxState';

export const useImpersonationCheck = () => {
  const {
    auth: {
      authToken: { accessToken },
    },
  } = useReduxState();

  const isImpersonated = useMemo(() => {
    if (!accessToken) return false;

    try {
      const decodedToken: models.DecodedToken = jwt_decode(accessToken);
      return !!decodedToken.impersonator;
    } catch (error) {
      return false;
    }
  }, [accessToken]);

  return { isImpersonated };
};
